(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-announcement-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sk-marquee')) {
    class SkMarquee extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.sk-marquee__track');
        this.group = this.querySelector('.sk-marquee__group');
        if (!this.track || !this.group) return;

        if (this.isDismissed()) {
          this.hidden = true;
          return;
        }

        this.speed = Math.max(parseFloat(this.dataset.speed) || 60, 1);
        this.mqMobile = window.matchMedia('(max-width: 749px)');
        this.mqMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onModeChange = () => this.setup();
        this.mqMobile.addEventListener('change', this.onModeChange);
        this.mqMotion.addEventListener('change', this.onModeChange);

        this.resizeObserver = new ResizeObserver(() => {
          if (!this.classList.contains('is-static')) this.fill();
        });
        this.resizeObserver.observe(this);

        this.intersectionObserver = new IntersectionObserver(([entry]) => {
          this.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
        this.intersectionObserver.observe(this);

        this.bindControls();
        this.startCountdowns();
        this.setup();

        this.onBlockSelect = (e) => this.handleBlockSelect(e, true);
        this.onBlockDeselect = (e) => this.handleBlockSelect(e, false);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.intersectionObserver?.disconnect();
        this.mqMobile?.removeEventListener('change', this.onModeChange);
        this.mqMotion?.removeEventListener('change', this.onModeChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        clearInterval(this.slideTimer);
        clearInterval(this.countdownTimer);
      }

      get isStaticMode() {
        return this.mqMotion.matches || (this.classList.contains('sk-marquee--static-mobile') && this.mqMobile.matches);
      }

      setup() {
        clearInterval(this.slideTimer);
        if (this.isStaticMode) {
          this.classList.add('is-static');
          this.classList.remove('is-ready');
          this.startSlider();
        } else {
          this.classList.remove('is-static');
          this.items().forEach((el) => el.classList.remove('is-active'));
          this.fill();
        }
      }

      items() {
        return Array.from(this.group.querySelectorAll('.sk-marquee__item'));
      }

      /* Clone the group until the track covers the viewport twice, then shift by exactly one group width. */
      fill() {
        const viewport = this.querySelector('.sk-marquee__viewport');
        const groupWidth = this.group.getBoundingClientRect().width;
        if (!groupWidth || !viewport) return;

        const needed = Math.max(2, Math.ceil(viewport.clientWidth / groupWidth) + 1);
        const groups = this.track.querySelectorAll('.sk-marquee__group');

        for (let i = groups.length; i < needed; i++) {
          const clone = this.group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          this.track.appendChild(clone);
        }
        for (let i = groups.length - 1; i >= needed; i--) groups[i].remove();

        this.style.setProperty('--sk-shift', `${groupWidth}px`);
        this.style.setProperty('--sk-duration', `${(groupWidth / this.speed).toFixed(2)}s`);
        this.classList.add('is-ready');
      }

      startSlider(index = 0) {
        const items = this.items();
        if (!items.length) return;
        this.slideIndex = index % items.length;
        const show = () => items.forEach((el, i) => el.classList.toggle('is-active', i === this.slideIndex));
        show();
        if (items.length < 2 || this.mqMotion.matches) return;
        this.slideTimer = setInterval(() => {
          if (this.classList.contains('is-paused')) return;
          this.slideIndex = (this.slideIndex + 1) % items.length;
          show();
        }, 4000);
      }

      bindControls() {
        const pauseBtn = this.querySelector('[data-pause]');
        pauseBtn?.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          pauseBtn.setAttribute('aria-pressed', String(paused));
          pauseBtn.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
        });

        this.querySelector('[data-dismiss]')?.addEventListener('click', () => {
          this.hidden = true;
          const key = this.dataset.dismissKey;
          const days = parseInt(this.dataset.dismissDays, 10) || 7;
          if (!key || window.Shopify?.designMode) return;
          try {
            localStorage.setItem(key, String(Date.now() + days * 86400000));
          } catch (e) {}
        });
      }

      isDismissed() {
        const key = this.dataset.dismissKey;
        if (!key || window.Shopify?.designMode) return false;
        try {
          const until = parseInt(localStorage.getItem(key), 10);
          if (until && until > Date.now()) return true;
          if (until) localStorage.removeItem(key);
        } catch (e) {}
        return false;
      }

      startCountdowns() {
        const nodes = () => this.querySelectorAll('.sk-marquee__countdown');
        if (!nodes().length) return;
        const pad = (n) => String(n).padStart(2, '0');

        const tick = () => {
          let anyEnded = false;
          nodes().forEach((node) => {
            const end = new Date(String(node.dataset.end).trim().replace(' ', 'T')).getTime();
            const diff = end - Date.now();
            if (isNaN(end) || diff <= 0) {
              if (node.style.display !== 'none') {
                node.style.display = 'none';
                const sep = node.nextElementSibling;
                if (sep?.classList.contains('sk-marquee__sep')) sep.style.display = 'none';
                anyEnded = true;
              }
              return;
            }
            const d = Math.floor(diff / 86400000);
            const h = Math.floor((diff / 3600000) % 24);
            const m = Math.floor((diff / 60000) % 60);
            const sec = Math.floor((diff / 1000) % 60);
            const time = node.querySelector('[data-time]');
            if (time) time.textContent = `${d > 0 ? pad(d) + 'd ' : ''}${pad(h)}h ${pad(m)}m ${pad(sec)}s`;
          });
          if (anyEnded && !this.classList.contains('is-static')) this.fill();
        };
        tick();
        this.countdownTimer = setInterval(tick, 1000);
      }

      handleBlockSelect(event, selected) {
        if (event.detail?.sectionId !== this.dataset.sectionId) return;
        this.classList.toggle('is-paused', selected);
        if (selected && this.classList.contains('is-static')) {
          const index = this.items().findIndex((el) => el.dataset.blockId === event.detail.blockId);
          if (index > -1) {
            clearInterval(this.slideTimer);
            this.startSlider(index);
          }
        }
      }
    }

    customElements.define('sk-marquee', SkMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mq = matchMedia('(min-width: 750px)');
    const sync = () => document.querySelectorAll('.sk-foot__nav').forEach((d) => { d.open = mq.matches; });
    sync();
    mq.addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sk-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sk-sticky-atc')) {
    class SkStickyAtc extends HTMLElement {
      connectedCallback() {
        this.mainButton = this.findMainButton();
        this.form = this.querySelector('form');
        this.form?.addEventListener('submit', this.onSubmit);
        if (!this.mainButton || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
          return;
        }
        this.observer = new IntersectionObserver(([entry]) => {
          const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.classList.toggle('is-visible', scrolledPast);
        });
        this.observer.observe(this.mainButton);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.form?.removeEventListener('submit', this.onSubmit);
      }

      findMainButton() {
        const candidates = document.querySelectorAll('form[action*="/cart/add"] [type="submit"], button[name="add"]');
        return Array.from(candidates).find((btn) => !this.contains(btn)) || null;
      }

      // Re-use the theme's own add-to-cart flow (cart drawer, selected variant) when possible.
      onSubmit = (event) => {
        const main = this.mainButton;
        if (main && !main.disabled) {
          event.preventDefault();
          main.click();
        }
      };
    }
    customElements.define('sk-sticky-atc', SkStickyAtc);
  }

  } catch(e) { console.error(e); }
})();
})();
